import React from 'react';
import LeadsBoard from '../../components/dashboard/LeadsBoard';
import GrowthBoard from '../../components/dashboard/GrowthBoard';
import AccountsTable from '../../components/dashboard/AccountsBoard';
import IntentLeadsBoard from '../../components/dashboard/IntentLeadsBoard';

const DashboardWidgets = () => {
  const isIntentLeadEnabled = process.env.REACT_APP_IS_INTENT_LEAD_TASK_ENABLED === 'true';

  return (
    <>
      <LeadsBoard />
      <GrowthBoard />
      <AccountsTable />
      {isIntentLeadEnabled && <IntentLeadsBoard />}
    </>
  );
};

export default DashboardWidgets;
